export const filterTableConfig = {
  itemsPerPage: 10,
  minItemsPerPage: 5,
  startingPage: 1,
  itemsPerPageOptions: [10, 25, 100],
  itemsPerPageOptionsSmall: [5, 10, 25, 100],
  itemsPerPageOptionsMini: [3, 5, 10],
  maximumItemsPerPage: 100000,
};
